import { Injectable } from '@angular/core';
import { UtilityService } from 'src/app/core/shared/utility.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ResposeGeneric } from 'src/app/core/shared/respose-generic';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FacultyService {
  uriFaculty =  environment.urlServices + 'facultades';

  constructor(private httpClient: HttpClient, private utilityService: UtilityService) { }

  getFaculty(): Observable<ResposeGeneric> {
    return this.httpClient.get<ResposeGeneric>(this.uriFaculty);
  }
}
